export default __webpack_public_path__ + "static/media/marker-start.c51334f2.png";